import styled from "styled-components";
import { Card } from "../../components/Card";

export const Positioning = styled(Card)`
  position: fixed;
  bottom: 50px;
  right: 10px;
  z-index: 15001;
  overflow: visible;
`;


export const Container = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
`;


export const TooltipContainer = styled.div<{ $isOpen?: boolean }>`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  color: #000;
  background-color: ${props => props.$isOpen ? '#1565c0' : '#fff'};
  box-shadow: ${props => props.$isOpen 
    ? '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)' 
    : '0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)'};
  text-transform: none;
  cursor: pointer;
  svg {
    transition: color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    color: ${props => props.$isOpen ? '#fff' : '#000'};
  }
  &:hover{
    text-decoration: none;
    background-color: #1565c0;
    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
    svg {
      color: #fff;
    }
  }
`;

export const TooltipFloating = styled.div`
  display: flex;
  flex-direction: column;
  width: max-content;
  min-width: 200px;
  box-sizing: border-box;
  padding: 12px 14px;
  border-radius: 8px;
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14),
    0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  background-color: #fff;
  overflow: hidden;
`;

export const TooltipRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  white-space: nowrap;

  > span {
    font-size: 16px;
    font-weight: 700;
    flex-shrink: 0;
  }

  > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    flex-shrink: 0;
  }

  > div > span {
    font-size: 16px;
    font-weight: 700;
    min-width: 40px;
    text-align: center;
  }

  button {
    width: 28px;
    height: 28px;
    min-width: 28px;
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    line-height: 1;
    border: 0;
    border-radius: 4px;
    transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    color: #fff;
    background-color: #1976d2;
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14),
      0px 1px 5px 0px rgba(0, 0, 0, 0.12);
    cursor: pointer;
    padding: 0;

    &:hover:not(:disabled) {
      background-color: #1565c0;
    }

    &:disabled {
      background-color: #bdbdbd;
      box-shadow: none;
      cursor: not-allowed;
    }
  }
`;
